<div class="flex h-full bg-gray-100 overflow-hidden">
  <!-- Lista utenti laterale -->
  <div class="w-80 bg-white border-r border-gray-200 flex flex-col shrink-0 min-h-0">
    <div class="p-4 border-b border-gray-200 shrink-0">
      <h2 class="text-xl font-semibold mb-3">Messaggi</h2>
      <input
        class="w-full border border-gray-300 rounded px-3 py-2 text-sm"
        type="text"
        placeholder="Cerca utente..."
        [ngModel]="searchQuery()"
        (ngModelChange)="searchQuery.set($event)"
      />
    </div>

    <div class="flex-1 overflow-y-auto min-h-0">
      @if (isLoadingUsers()) {
        <div class="flex justify-center items-center h-32">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        </div>
      } @else if (filteredUsers().length === 0) {
        <div class="flex justify-center items-center h-32 text-gray-400 text-sm">
          Nessun utente trovato
        </div>
      } @else {
        @for (user of filteredUsers(); track user.id) {
          <div
            (click)="selectUser(user)"
            class="flex items-center gap-3 p-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors"
            [class.bg-blue-50]="selectedUser()?.id === user.id">
            <!-- Avatar -->
            <div class="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0 text-sm font-semibold text-gray-600">
              {{ user.firstName.charAt(0) }}{{ user.lastName.charAt(0) }}
            </div>
            <div class="flex-1 min-w-0">
              <div class="font-semibold text-sm truncate">{{ user.firstName }} {{ user.lastName }}</div>
              <div class="text-xs text-gray-500 truncate">{{ user.email }}</div>
            </div>
            <!-- Indicatore chat esistente -->
            @if (hasExistingChat().has(user.id)) {
              <div class="w-2 h-2 rounded-full bg-green-500 shrink-0"></div>
            }
          </div>
        }
      }
    </div>
  </div>

  <!-- Area chat -->
  <div class="flex-1 overflow-hidden">
    @if (isOpeningChat()) {
      <div class="flex justify-center items-center h-full">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    } @else if (activeChatId()) {
      <wun-chatbot
        [chatId]="activeChatId()"
        [userId]="currentUserId()"
        [targetUserId]="selectedUser()!.id">
      </wun-chatbot>
    } @else {
      <div class="flex justify-center items-center h-full text-gray-400">
        Seleziona un utente per aprire la chat
      </div>
    }
  </div>
</div>
